var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BN } from "@coral-xyz/anchor";
import { PublicKey, SystemProgram } from "@solana/web3.js";
import { ItemStatus, } from "./types";
import { getSwapIdentityFromData } from "./getSwapIdentityFromData.function";
import { neoTypes } from "..";
import { getProgram } from "./getProgram.obj";
import { getMerkleTreeAndIndex } from "./getCNFTData.function";
export function swapDataConverter(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var swapDatas, _loop_1, _a, _b, _c, _i, user, itemsNfts, itemsSol, items;
        var _this = this;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    swapDatas = [];
                    if (!!Data.clusterOrUrl && !!Data.connection) {
                    }
                    else if (!!Data.clusterOrUrl) {
                        Data.connection = getProgram({ clusterOrUrl: Data.clusterOrUrl }).provider.connection;
                    }
                    else if (!!Data.connection) {
                        Data.clusterOrUrl = Data.connection.rpcEndpoint;
                    }
                    if (!Data.connection || !Data.clusterOrUrl)
                        throw "there should be a Connection or a ClusterOrUrl";
                    _loop_1 = function (user) {
                        var ccurency;
                        return __generator(this, function (_e) {
                            switch (_e.label) {
                                case 0:
                                    console.log("user", user, Data.swapInfo.users[user]);
                                    if (!(Data.swapInfo.users[user].items.give.length > 0)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, Promise.all(Data.swapInfo.users[user].items.give.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                            var isCompressed, merkleTree, index, balance, signa, error_1, _a, merkleTreefound, indexFound;
                                            return __generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0:
                                                        if (!Data.connection || !Data.clusterOrUrl)
                                                            throw "there should be a Connection or a ClusterOrUrl";
                                                        isCompressed = false;
                                                        merkleTree = new PublicKey(item.address);
                                                        index = new BN(0);
                                                        _b.label = 1;
                                                    case 1:
                                                        _b.trys.push([1, 5, , 6]);
                                                        return [4 /*yield*/, Data.connection.getBalance(new PublicKey(item.address))];
                                                    case 2:
                                                        balance = _b.sent();
                                                        if (!(balance === 0)) return [3 /*break*/, 4];
                                                        return [4 /*yield*/, Data.connection.getSignaturesForAddress(new PublicKey(item.address))];
                                                    case 3:
                                                        signa = _b.sent();
                                                        if (signa.length === 0) {
                                                            isCompressed = true;
                                                        }
                                                        _b.label = 4;
                                                    case 4: return [3 /*break*/, 6];
                                                    case 5:
                                                        error_1 = _b.sent();
                                                        isCompressed = true;
                                                        console.log("error", error_1);
                                                        return [3 /*break*/, 6];
                                                    case 6:
                                                        if (!isCompressed) return [3 /*break*/, 8];
                                                        return [4 /*yield*/, getMerkleTreeAndIndex({
                                                                tokenId: new PublicKey(item.address),
                                                                Cluster: Data.clusterOrUrl.includes("mainnet")
                                                                    ? "mainnet-beta"
                                                                    : "devnet",
                                                            })];
                                                    case 7:
                                                        _a = _b.sent(), merkleTreefound = _a.merkleTree, indexFound = _a.index;
                                                        merkleTree = merkleTreefound;
                                                        index = indexFound;
                                                        _b.label = 8;
                                                    case 8:
                                                        item.getters.map(function (toDest) {
                                                            console.log(user, " give ", toDest.amount, " items ", item.address, "to destinary", toDest.address);
                                                            swapDatas.push({
                                                                isNft: true,
                                                                isCompressed: isCompressed,
                                                                mint: new PublicKey(item.address),
                                                                merkleTree: merkleTree,
                                                                index: index,
                                                                owner: new PublicKey(Data.swapInfo.users[user].address),
                                                                destinary: new PublicKey(toDest.address),
                                                                amount: new BN(toDest.amount),
                                                                status: neoTypes.ItemStatus.NFTPending,
                                                            });
                                                        });
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); }))];
                                case 1:
                                    _e.sent();
                                    _e.label = 2;
                                case 2:
                                    if (Data.swapInfo.users[user].items.token.amount !== 0) {
                                        console.log(user, "token", Data.swapInfo.users[user].items.token.amount);
                                        ccurency = new PublicKey(Data.swapInfo.currency);
                                        swapDatas.push({
                                            owner: new PublicKey(Data.swapInfo.users[user].address),
                                            isNft: false,
                                            isCompressed: false,
                                            amount: new BN(Data.swapInfo.users[user].items.token.amount),
                                            destinary: ccurency,
                                            mint: ccurency,
                                            merkleTree: ccurency,
                                            index: new BN(0),
                                            status: Data.swapInfo.users[user].items.token.amount < 0
                                                ? ItemStatus.SolPending
                                                : ItemStatus.SolToClaim,
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _a = Data.swapInfo.users;
                    _b = [];
                    for (_c in _a)
                        _b.push(_c);
                    _i = 0;
                    _d.label = 1;
                case 1:
                    if (!(_i < _b.length)) return [3 /*break*/, 4];
                    _c = _b[_i];
                    if (!(_c in _a)) return [3 /*break*/, 3];
                    user = _c;
                    return [5 /*yield**/, _loop_1(user)];
                case 2:
                    _d.sent();
                    _d.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    itemsNfts = swapDatas.filter(function (x) {
                        return x.isNft == true;
                    });
                    itemsSol = swapDatas.filter(function (x) {
                        return x.isNft == false;
                    });
                    items = itemsNfts.concat(itemsSol);
                    // console.log("items", items);
                    return [2 /*return*/, getSwapIdentityFromData({
                            swapData: {
                                status: 0,
                                initializer: SystemProgram.programId,
                                items: items,
                                preSeed: Data.swapInfo.preSeed ? Data.swapInfo.preSeed : "0000",
                                acceptedPayement: Data.swapInfo.currency
                                    ? new PublicKey(Data.swapInfo.currency)
                                    : SystemProgram.programId,
                                nbItems: items.length,
                            },
                            clusterOrUrl: Data.clusterOrUrl,
                        })];
            }
        });
    });
}
export function invertedSwapDataConverter(Data) {
    var swapStatusMap = {
        0: "initializing",
        1: "active",
        2: "finalizing",
        3: "finalized",
        4: "canceling",
        5: "canceled",
    };
    var itemStatusMap = {
        10: "pending",
        11: "pending",
        20: "deposited",
        21: "deposited",
        22: "deposited",
        30: "claimed",
        31: "claimed",
        110: "returned",
        111: "returned",
    };
    var status = swapStatusMap[Data.swapData.status] || undefined;
    var swapInfo = {
        currency: Data.swapData.acceptedPayement.toBase58(),
        preSeed: Data.swapData.preSeed,
        status: status,
        users: [],
    };
    var uusers = {};
    var _loop_2 = function (itemNb) {
        var item = Data.swapData.items[itemNb];
        if (!!!uusers[item.owner.toBase58()])
            uusers[item.owner.toBase58()] = { give: [], get: [], token: { amount: 0 } };
        if (!!!uusers[item.destinary.toBase58()])
            uusers[item.destinary.toBase58()] = { give: [], get: [], token: { amount: 0 } };
        if (item.isNft) {
            var giversMint = uusers[item.owner.toBase58()].give.filter(function (x) {
                return x.address == item.mint.toBase58();
            });
            var getterMint = uusers[item.destinary.toBase58()].get.filter(function (x) {
                return x.address == item.mint.toBase58();
            });
            if (giversMint.length == 0) {
                uusers[item.owner.toBase58()].give.push({
                    address: item.mint.toBase58(),
                    amount: item.amount.toNumber(),
                    getters: [
                        {
                            address: item.destinary.toBase58(),
                            amount: item.amount.toNumber(),
                            status: itemStatusMap[item.status],
                        },
                    ],
                });
            }
            else {
                giversMint[0].amount += item.amount.toNumber();
                giversMint[0].getters.push({
                    address: item.destinary.toBase58(),
                    amount: item.amount.toNumber(),
                    status: itemStatusMap[item.status],
                });
            }
            if (getterMint.length == 0) {
                uusers[item.destinary.toBase58()].get.push({
                    address: item.mint.toBase58(),
                    amount: item.amount.toNumber(),
                    givers: [
                        {
                            address: item.owner.toBase58(),
                            amount: item.amount.toNumber(),
                            status: itemStatusMap[item.status],
                        },
                    ],
                });
            }
        }
        else {
            if (uusers[item.owner.toBase58()].token.amount !== 0)
                throw "already tokens to send";
            uusers[item.owner.toBase58()].token.amount = item.amount.toNumber();
        }
    };
    for (var itemNb in Data.swapData.items) {
        _loop_2(itemNb);
    }
    // for (const itemNb in uusers) {
    //     console.log(
    //         itemNb,
    //         uusers[itemNb].status,
    //         "tokens",
    //         uusers[itemNb].token,
    //         "uusers \n give",
    //         uusers[itemNb].give[0],
    //         "\n get",
    //         uusers[itemNb].get[0]
    //     );
    // }
    swapInfo.users = Object.keys(uusers).map(function (user) {
        return { address: user, items: uusers[user] };
    });
    return swapInfo;
}
